export const SCHEMA_NAME = "CivilPapersHearingDates";

export const FIELDS = {
  CIVIL_PAPERS_HEARING_DATE_ID: "civilPapersHearingDateID",
  CIVIL_PAPER_ID: "civilPaperID",
  HEARING_DATE: "hearingDate",
  HEARING_TIME: "hearingTime",
  HEARING_LOCATION: "hearingLocation",
};
